const state = {
    summary: null,
    propertiesByType: [],
    propertiesByObjective: [],
    propertiesByCondition: [],
    propertiesByLocation: [],
    topProperties: [],
    priceAnalytics: null,
    agentPerformance: [],
    monthlyActivity: null,
    mySummary: null,
}
export default state;
